import http from "@/settings/apiSettings"

class GrilaSalarizareService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/RU_GrilaSalarizare", data)
    }
}
export default new GrilaSalarizareService()